import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Empty, Input, Radio, Select, Spin, Tooltip } from "antd";
import IconChevron from "@assets/icon_chevron.svg";
import { cloneDeep, get, map } from "lodash";
import InputMask from "react-input-mask";
import "./userField.scss";
const { Option } = Select;

const OptionVal = ({ option, handleChange, selectedValues }: any) => {
  const optionRef = useRef(null);

  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (get(optionRef, "current.clientWidth", 0) < get(optionRef, "current.scrollWidth", 0)) {
      setShowTooltip(true);
    }
  }, []);

  const isAllSelected = () => {
    return selectedValues.includes("ALL") && option.title !== "Select ALL";
  };

  return showTooltip ? (
    <Tooltip title={option.title}>
      <div ref={optionRef}>
        <Checkbox
          value={option.value}
          className={isAllSelected() ? "light-background" : ""}
          disabled={isAllSelected()}
          onChange={(e) => handleChange({ source: "checkbox", e })}
          checked={isAllSelected() || selectedValues.includes(option.value?.trim())}
        />
        <span>{option.title}</span>
      </div>
    </Tooltip>
  ) : (
    <div ref={optionRef}>
      <Checkbox
        value={option.value}
        className={isAllSelected() ? "light-background" : ""}
        disabled={isAllSelected()}
        onChange={(e) => handleChange({ source: "checkbox", e })}
        checked={isAllSelected() || selectedValues.includes(option.value?.trim())}
      />
      <span>{option.title}</span>
    </div>
  );
};

const SimpleSelect = (props: { handleSelect: (arg0: any) => void; value?: any; options: any; disabled?: boolean; loadingOptions?: boolean , className?: string}) => {
  return (
    <Select
      className={`ui-select-field ${props.className}`}
      placeholder="Select Option"
      optionFilterProp="children"
      onChange={(option: any) => props.handleSelect(option)}
      value={props.value}
      suffixIcon={
        <span>
          <img src={IconChevron} alt="chevron-icon" />
        </span>
      }
      showSearch
      notFoundContent={props.loadingOptions ? <Spin size="small" /> : <Empty />}
      filterOption={(input, option: any) => {
        return option.value.toLowerCase().includes(input.toLowerCase());
      }}
      disabled={props.disabled ? props.disabled : false}
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      {props?.options?.length > 0
        ? map(props?.options, (option: any) => {
            return (
              <Option key={option.value} value={option.value} className="filters-row-option">
                {option.title}
              </Option>
            );
          })
        : !props.loadingOptions && (
            <Option key="1" value="" className="filters-row-option">
              {" "}
            </Option>
          )}
    </Select>
  );
};

const MultiSelect = (props: { handleSelect: (arg0: any) => void; value?: any; options: any; disabled?: boolean; loadingOptions?: boolean; placeholder?: string , className?: string }) => {  
  const [dropdownToggle, setDropdownToggle] = useState<boolean>(false);
  const [selectedValues, setselectedValues] = useState<string[]>([]);
  const [dropdownOptions, setDropdownOptions] = useState<any[]>([]);
  useEffect(() => {
    if (props.value?.length > 0) {
      setselectedValues(props.value?.split("$|")?.map((element: string) => element?.trim()));
    } else {
      setselectedValues([]);
    }
    setDropdownOptions(props.options);
    sortDropDown({ selectedOptionValues: props.value?.split("$|"), selectdropdownOptions: props.options });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.options , props.value]);

  const sortDropDown = ({ selectedOptionValues = selectedValues, selectdropdownOptions = dropdownOptions }) => {
    let temp_dropdownOptions = cloneDeep(selectdropdownOptions);
    let selectedOptions: any[] = [];
    let unselectedOptions: any[] = [];
    if (temp_dropdownOptions?.length > 0) {
      temp_dropdownOptions.forEach((dropdownOption: any) => {
        if (selectedOptionValues?.indexOf(dropdownOption?.value) === -1) {
          unselectedOptions.push(dropdownOption);
        } else {
          selectedOptions.push(dropdownOption);
        }
      });
      setDropdownOptions([...selectedOptions, ...unselectedOptions]);
    }
  };

  const handleChange = ({ source, e }: any) => {
    let updatedSelectedvalues: string[] = [];
    if (source === "checkbox") {
      if (e.target.checked && !selectedValues.includes(e.target.value) && e?.target?.value?.trim()?.length > 0) {
        if (e.target.value === "ALL") {
          updatedSelectedvalues = ["ALL"];
        } else {
          updatedSelectedvalues = [...selectedValues, e.target.value];
        }
        setselectedValues(updatedSelectedvalues);
        props.handleSelect(updatedSelectedvalues.join("$|"));
      } else {
        if (e.target.value === "ALL") {
          updatedSelectedvalues = [];
        } else {
          updatedSelectedvalues = selectedValues.filter((val) => val !== e.target.value);
        }
        setselectedValues(updatedSelectedvalues);
        props.handleSelect(updatedSelectedvalues.join("$|"));
      }
    } else if (source === "dropdown" && !selectedValues.includes(e)) {
      if (e === "ALL") {
        updatedSelectedvalues = ["ALL"];
      } else {
        updatedSelectedvalues = [...selectedValues, e];
      }
      setselectedValues(updatedSelectedvalues);
      props.handleSelect(updatedSelectedvalues.join("$|"));
    }
  };

  const getDropdownDisplayValue = () => {
    let val: string | undefined = "";
    if (!dropdownToggle) {
      val =
        selectedValues?.length > 0
          ? `${selectedValues?.length > 0 ? selectedValues[0] : ""} 
         ${selectedValues?.length > 1 ? "(+" + (selectedValues?.length - 1) + ")" : ""}`
          : undefined;
    }
    return val;
  };

  return (
    <Select
      className={`ui-select-field ${props.className}`}
      placeholder={props.placeholder ? props.placeholder : "Select Option"}
      optionFilterProp="children"
      onChange={(option: any) => handleChange({ source: "dropdown", e: option })}
      onClick={() => setDropdownToggle(true)}
      onBlur={() => setDropdownToggle(false)}
      open={dropdownToggle}
      value={getDropdownDisplayValue()}
      suffixIcon={
        <span className="down-arrow">
          <img src={IconChevron} alt="chevron-icon" />
        </span>
      }
      disabled={props.disabled ? props.disabled : false}
      showSearch
      notFoundContent={props.loadingOptions ? <Spin size="small" /> : <Empty />}
      filterOption={(input, option: any) => {
        return option.value.toLowerCase().includes(input.toLowerCase());
      }}
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      {dropdownOptions?.length > 0
        ? map(dropdownOptions, (option) => {
            return (
              <Option key={option?.value} value={option?.value} className="filters-row-option">
                <OptionVal option={option} handleChange={handleChange} selectedValues={selectedValues} />
              </Option>
            );
          })
        : !props.loadingOptions && (
            <Option key="1" value="" className="filters-row-option">
              {" "}
            </Option>
          )}
    </Select>
  );
};

const UserField = (props: any) => {
  if (props.type === "ACTN-FREETXT") {
    return (
      <Input
        value={props.field.value}
        status={props.field.errorMessage ? "error" : ""}
        onChange={(e) => {
          props.onChange(e.target.value, props.field, props.action);
        }}
        className={props.className}
      />
    );
  } else if (props.type === "ACTN-FREETXT-NEDIT" && props.action !== "EDIT") {
    return <Input value={props.field.value} status={props.field.errorMessage ? "error" : ""} className={props.className} onChange={(e) => props.onChange(e.target.value, props.field, props.action)} />;
  } else if (props.type === "ACTN-1DRPDWN") {
    return (
      <SimpleSelect
        handleSelect={(value) => props.onChange(value, props.field, props.action)}
        value={props.field.value}
        options={props.dropdownData}
        disabled={false}
        loadingOptions={props.dropdownData <= 0}
        className={props.className}
      />
    );
  } else if (props.type === "ACTN-MSELDRPDWN") {
    return (
      <MultiSelect
        handleSelect={(value) => props.onChange(value, props.field, props.action)}
        value={props.field.value}
        options={props.dropdownData}
        disabled={false}
        loadingOptions={props.dropdownData <= 0}
        className={props.className}
      />
    );
  } else if (props.type === "ACTN-RADIO") {
    return (
      <Radio.Group onChange={({ target: { value } }) => props.onChange(value, props.field, props.action)} value={props.field.value} className={props.className}>
        {props.field.possibleValues.map((val : string) => <Radio value={val}>{val}</Radio>)}
      </Radio.Group>
    );
  } else if (props.type === "ACTN-PHONE") {
    return (
      <InputMask
        mask="+\1 999 999 9999"
        maskPlaceholder={null}
        className={`ant-input member-item ${props.field.errorMessage ? "input-error" : ""} ${props.className}`}
        value={props.field.value || ''}
        onChange={(e) => props.onChange(e.target.value, props.field, props.action)}
      />
    );
  } else {
    return <></>;
  }
};

export default UserField;